/* eslint-disable react/no-unescaped-entities */
import {React} from "react";
import   "../pages/styles.css";




const CurrentPlans = () => {

     return (
<div style={{background:"#eceff3f6"}}>
      
          <h1 className="boldFancyHeadFontCenter">Our 2025-2026 Season Schedule</h1>
          <h3 className="boldFancyHeadFontCenter2">The What? When? Where? Who? and By whom? for our festivities</h3>
          <br/>
          <br/>

          <div className={`blackBodyFontCenter`}>
            Our gatherings this year are a little different from our standard.<br></br>
            The <a href="https://www.northwoodclub.org/">Northwood Country Club</a>, where we normally host our events, will be completely remodelled.<br></br>
            To that end, two of our events this year will be held at the 
            <a href="https://www.lakewoodcc.com/"> Lakewood Country Club</a>.<br></br>
            So, with no futher ado, here is this season`s schedule.
          </div>
         <br></br>
         <br></br>
         <div className={`boldFancyHeadFontCenter2`} >WHAT: Black and Orange Ball</div>
         <div className={`blackBodyFontCenter`}>Our annual Fall Festival that celebrates fall and Halloween</div>
         <div className={`boldFancyHeadFontCenter2`}>WHEN: Friday, October 10, 2025</div>
         <div className={`boldFancyHeadFontCenter2`}>WHERE: <a href="https://www.northwoodclub.org/">Northwood Country Club</a></div>
         <div className={`boldFancyHeadFontCenter2`}>WHO: Dance Chair: Melissa Long</div>
         <div className={`boldFancyHeadFontCenter2`}>BY WHOM: The Kelley Fletcher Band</div>
         <br></br>
         <br></br>
         <div className={`boldFancyHeadFontCenter2`}>WHAT: A Little Night Music</div>
         <div className={`blackBodyFontCenter`}>Our annual Winter Festival that celebrates the crystal beauty of a winter wonderland</div>
         <div className={`blackBodyFontCenterBold`}>Due to inclement weather on January 24, 2026, we had to reschedule our date and band</div>
         <div className={`boldFancyHeadFontCenter2`}>WHEN: <s>Saturday, January 24, 2026</s></div>
         <div className={`boldFancyHeadFontCenter2`}>WHERE: <a href="https://www.lakewoodcc.com">Lakewood Country Club</a></div>
         <div className={`boldFancyHeadFontCenter2`}>WHO: Dance Chairs: Pete & Gillian Gonzales</div>
         <div className={`boldFancyHeadFontCenter2`}>BY WHOM: <s><a href="https://www.markvansicklemusic.com/dfw-music-makers">The DFW Music Makers</a></s></div>
         <br/>
         <div className={`boldFancyHeadFontCenter2`}>NEW &quot;WHEN&quot;: Saturday, February 14, 2026 <br/>(Yeah! We get a Valentine's Dance!)</div>
         <div className={`boldFancyHeadFontCenter2`}>NEW &quot;BY WHOM&quot;: <a href="https://docgibbsentertainment.com/">The Doc Gibbs Band</a></div>
         <br></br>
         <br></br>
         <div className={`boldFancyHeadFontCenter2`}>WHAT: Saturday Night Fever</div>
         <div className={`blackBodyFontCenter`}>Our annual Spring Festival that celebrates the rebirth of the world.</div>
         <div className={`boldFancyHeadFontCenter2`}>WHEN: Saturday, March 28, 2026</div>
         <div className={`boldFancyHeadFontCenter2`}>WHERE: <a href="https://www.lakewoodcc.com">Lakewood Country Club</a></div>
         <div className={`boldFancyHeadFontCenter2`}>WHO: Dance Chairs: Gail Horne</div>
         <div className={`boldFancyHeadFontCenter2`}>BY WHOM: <a href="https://www.davetannermusic.com/">The Dave Tanner Band</a></div>

    </div>

  )
};
   
export default CurrentPlans;